import {DatePicker as MuiDatePicker} from "@mui/x-date-pickers";
import React from "react";
import {TextFieldBase} from "../textfield/TextFieldBase";

interface DatePickerFieldProps<TInputDate, TDate = TInputDate> {
    label: string;
    value: TInputDate | null | undefined;
    onChange: (value: TDate | null) => void;
    required?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    error?: string;
    helperText?: string;
}

export function DatePicker<TInputDate, TDate = TInputDate>(props: Readonly<DatePickerFieldProps<TInputDate, TDate>>) {
    const {label, value, onChange, required, readOnly, disabled, error, helperText} = props;

    return (
            <MuiDatePicker
                    label={label}
                    value={value ?? null}
                    onChange={onChange}
                    disabled={disabled}
                    readOnly={readOnly}
                    renderInput={(params) => <TextFieldBase {...params}
                            error={!!error}
                            helperText={error ?? helperText}
                            required={required}
                            readOnly={readOnly}
                            inputProps={{
                                ...params.inputProps,
                                placeholder: readOnly ? "" : params.inputProps?.placeholder
                            }}/>
                    }/>
    );
}
